import { AxiosInstance } from 'axios';
import ColisportApiResource from './colisport-api-resource.model';
import { getToken } from './auth-session-storage.service';

export interface AdminMigrationResult {
  created: number;
  skipped: number;
  errors: number;
}

export interface AdminRecoveryResult {
  status: string;
  subscriptionId?: string;
}

export default class AdminApi implements ColisportApiResource {
  readonly apiUrlPath = '/admin';

  constructor(readonly httpClient: AxiosInstance) {}

  private get authHeaders() {
    return { Authorization: `Bearer ${getToken()}` };
  }

  /** POST /admin/subscriptions/plans — create a new subscription plan */
  async createSubscriptionPlan(dto: Record<string, unknown>): Promise<any> {
    const { data } = await this.httpClient.post(`${this.apiUrlPath}/subscriptions/plans`, dto, {
      headers: this.authHeaders,
    });
    return data;
  }

  /** POST /admin/migrations/init-free-subscriptions — backfill FREE subscriptions */
  async initFreeSubscriptions(dryRun?: boolean): Promise<AdminMigrationResult> {
    const { data } = await this.httpClient.post(
      `${this.apiUrlPath}/migrations/init-free-subscriptions`,
      undefined,
      { params: dryRun ? { dryRun: 'true' } : undefined, headers: this.authHeaders },
    );
    return data;
  }

  /** POST /admin/migrations/subscriptions/recover-pending — recover a stuck PENDING subscription */
  async recoverPendingSubscription(revolutSubscriptionId: string): Promise<AdminRecoveryResult> {
    const { data } = await this.httpClient.post(
      `${this.apiUrlPath}/migrations/subscriptions/recover-pending`,
      { revolutSubscriptionId },
      { headers: this.authHeaders },
    );
    return data;
  }

  /** POST /admin/subscriptions/manual-refund — issue a manual pro-rata refund */
  async manualRefund(
    userEmail: string,
    revolutSubscriptionId: string,
    refundFromDate: string,
  ): Promise<{ creditNoteId: string; refundAmountCents: number; refundId?: string }> {
    const { data } = await this.httpClient.post(
      `${this.apiUrlPath}/subscriptions/manual-refund`,
      { userEmail, revolutSubscriptionId, refundFromDate },
      { headers: this.authHeaders },
    );
    return data;
  }

  /** POST /admin/shipments/:colisportID/resend-agency-notification — resend GLS agency notification */
  async resendAgencyNotification(
    colisportID: string,
  ): Promise<{ success: boolean; message: string }> {
    const { data } = await this.httpClient.post(
      `${this.apiUrlPath}/shipments/${colisportID}/resend-agency-notification`,
      undefined,
      { headers: this.authHeaders },
    );
    return data;
  }
}
